import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import { NavDropdown } from 'react-bootstrap';
// Redux
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

// Style
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';

// Internal Components
import Logout from '../../Logout';
import HeaderModal from '../../HeaderModal';
import MenuItemLink from '../../MenuItemLink';

import { choseToTheme } from '../../../actions/getCurrencyRates';
import { openHeaderModal } from '../../../actions/modalActions';
import { setUserLogout } from '../../../actions/logout';
import { formatLocale } from '../../../helpers/formatLocale';
import getAdminUserStatusQuery from './getAdminUserStatus.graphql';
import { withQuery } from '../../../hoc/withGraphql';

// Translation
import messages from '../../../locale/messages';

import { DarkModeIcon, LanguageSvgIcon, LightModeIcon, LogOutSvgIcon, MainSiteSvgIcon } from '../../Common/Assets/SvgComponent/SiteAdminSvgIcon';
import { adminLogout } from '../../../actions/siteadmin/logout';
import NavLink from '../../NavLink/NavLink';
import s from './AdminNavigation.css';


class AdminNavigation extends React.Component {

  static propTypes = {
    className: PropTypes.string,
  };

  render() {
    const { openHeaderModal, currentLocale, choseToTheme, selectedTheme, hideCurrency, checkLoginUserExist: { userExistloading, getAdminUserStatus }, setUserLogout, adminLogout } = this.props;

    if (!userExistloading && getAdminUserStatus) {
      if (getAdminUserStatus.userExistStatus) {
        const isBrowser = typeof window !== 'undefined';
        if (isBrowser) {
          window.location.reload();
          setUserLogout({ isAdmin: true });
        }
      }
    }

    return (
      <ul className={s.adminHeaderWrapper}>
        <NavDropdown title={
          <>
            {
              (selectedTheme && selectedTheme === "light") &&
              <>
                <LightModeIcon />
                <span className={s.adminHeaderListText}><FormattedMessage {...messages.lightMode} /></span>
              </>
            }
            {

              (selectedTheme && selectedTheme === "dark") &&
              <>
                <DarkModeIcon />
                <span className={s.adminHeaderListText}> <FormattedMessage {...messages.darkMode} /></span>
              </>
            }
          </>
        }

          noCaret id="basic-nav-dropdown1" className={cx(s.adminHeaderList, 'adminHeaderDropdownMenu')}>
          <MenuItemLink to="#" onClick={() => { choseToTheme('light') }} >
            <div className={cx(s.adminDropDownHeaderList, selectedTheme === 'light' && s.languageDropdownSelected)}>
              <LightModeIcon />
              <FormattedMessage {...messages.lightMode} />
            </div>
          </MenuItemLink>
          <MenuItemLink to="#" onClick={() => { choseToTheme('dark') }}>
            <div className={cx(s.adminDropDownHeaderList, selectedTheme === 'dark' && s.languageDropdownSelected)}>
              <DarkModeIcon />
              <FormattedMessage {...messages.darkMode} />
            </div>
          </MenuItemLink>
        </NavDropdown>
        <NavLink onClick={(e) => openHeaderModal('languageModal')} className={s.adminHeaderList} >
          <span className={s.adminHeaderListIcon}>
            <LanguageSvgIcon />
          </span>
          <span className={s.adminHeaderListText}>{formatLocale(currentLocale)}</span>
        </NavLink>

        <NavLink to="/" className={s.adminHeaderList}>
          <span className={s.adminHeaderListIcon}>
            <MainSiteSvgIcon />
          </span>
          <span className={s.adminHeaderListText}><FormattedMessage {...messages.goToMainSite} /></span>
        </NavLink>


        <li>
          <form action={'/admin-logout'} method="post">
            <button type="submit" className={s.logoutAdminHeaderList}>
              <span className={s.adminHeaderListIcon}>
                <LogOutSvgIcon />
              </span>
              <span className={s.adminHeaderListText}>
                <FormattedMessage {...messages.logout} />
              </span>
            </button>
          </form>
        </li>
        <HeaderModal modalType={'languageModal'} hideCurrency={true} />
      </ul>
    );
  }

}
const mapState = state => ({
  currentLocale: state.intl.locale,
  selectedTheme: state.currency.theme
});
const mapDispatch = {
  adminLogout,
  openHeaderModal,
  choseToTheme,
  setUserLogout
};

export default
  compose(
    injectIntl,
    withStyles(s),
    withQuery(getAdminUserStatusQuery, {
      name: 'checkLoginUserExist',
      options: {
        ssr: false,
        pollInterval: 5000,
      },
    }),
    (connect(mapState, mapDispatch)))(AdminNavigation);